// extracted by mini-css-extract-plugin
export var actionButton = "_e4-0";
export var attachmentLine = "_e4-1";
export var fileInput = "_e4-2";
export var fileUploadWrapper = "_e4-4";
export var footer = "_e4-3";
export var modalContent = "_e4-5";
export var paperclip = "_e4-6";
export var quillEditor = "_e4-7";